import React from 'react';
import {Table, TableBody, TableCell, TableRow} from '@material-ui/core';
import styled from 'styled-components';

interface SummaryTableProps {
  rows: [string, string | number | null][];
  beforeImageGenerationDate?: boolean;
}

const StyledTableRow = styled(TableRow)<{disabled?: boolean}>`
  height: 100%;
  opacity: ${props => (props.disabled ? 0.25 : 1)};
  font-size: small !important;

  @media (max-width: 950px) {
    font-size: x-small !important;
  }
`;

const StyledTableKey = styled(TableCell)<{disabled?: boolean}>`
  opacity: ${props => (props.disabled ? 0.25 : 1)};
  font-size: small !important;

  @media (max-width: 950px) {
    font-size: x-small !important;
  }
`;

const StyledTableValue = styled(TableCell)<{disabled?: boolean; smallertext: string}>`
  opacity: ${props => (props.disabled ? 0.25 : 1)};
  padding: 9px !important;
  font-size: ${props => (props.smallertext ? 'small' : 'medium')} !important;
  width: ${props => (props.smallertext ? '58%' : null)};

  @media (max-width: 950px) {
    font-size: ${props => (props.smallertext ? 'x-small' : 'x-small')} !important;
  }
`;

const SummaryTable = ({rows, beforeImageGenerationDate}: SummaryTableProps) => {
  return (
    <Table>
      <TableBody>
        {rows.map(([key, value], idx) => (
          <StyledTableRow key={idx} disabled={!value}>
            <StyledTableKey>{key}</StyledTableKey>
            <StyledTableValue smallertext={beforeImageGenerationDate ? 'true' : undefined} align="right">
              {value ?? '-'}
            </StyledTableValue>
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SummaryTable;
